import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'



import routesEmpresa from './empresa/routes'
import routesAdmin from './admin/routes' //
import routesPos from './pos/routes' //

Vue.use(VueRouter)


const routes = [
  // Contexto Empresa
  {
    path: '/',
    component: () => import('@/views/empresa/layout/EmpresaLayout.vue'),
    // Agregamos un nombre para que el router sepa dónde está
    name: 'empresa.root',
    meta: { context: 'empresa', requiresAuth: true },
    children: [...routesEmpresa],
  },

  // Contexto Admin
  {
    path: '/admin',
    component: () => import('@/views/admin/AdminLayout.vue'),
    meta: { context: 'admin', requiresAuth: true },
    children: [...routesAdmin],
  },

  // Contexto POS
  {
    path: '/pos',
    component: () => import('@/views/pos/PosLayout.vue'),
    meta: {
      context: 'pos',
      requiresAuth: true,
      requireArqueoCaja: true,
      requireCaja: true,
      requireSucursal: true
    },
    children: [...routesPos],
  },

  // Ruta Login
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/usuarios/Login.vue'),
    meta: { requiresAuth: false, public: true } // Agregamos public: true
  },

  // RUTA FALTANTE: Landing (La que pide tu Guard)
  {
    path: '/welcome',
    name: 'landing',
    component: () => import('@/views/LandingPage.vue'), // Asegúrate de que este componente exista
    meta: { public: true }
  },

  // RUTA FALTANTE: Error (Para frenar el bucle del catch)
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/ErrorPage.vue'),
    meta: { public: true }
  },

  // Comodín para 404
  {
    path: '*',
    redirect: '/'
  }
];

// ELIMINAMOS el .concat(), ya están incluidas en los children
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes // Usamos directamente el array limpio
});


import { checkEmpresa } from './guards/empresa';
import { checkAuth } from './guards/auth';
import { checkInitData } from './guards/initData';
import { checkRoleAccess } from './guards/roleAccess';
import { handleFinalValidations } from './guards/navigationHandlers';

const guards = [
  checkEmpresa,   // 1. ¿Existe la empresa? (Landing)
  checkAuth,      // 2. ¿Sesión activa? (Login)
  checkInitData,  // 3. ¿POS configurado? (Sucursal/Caja/Arqueo)
  checkRoleAccess // 4. ¿Tiene permiso al módulo? (Admin/Productos)
];

router.beforeEach(async (to, from, next) => {
  const prefix = '[Router Pipeline]';

  // 1. EL FILTRO MAESTRO: ¿Existe la empresa?
  // Se ejecuta SIEMPRE, incluso para la landing.
  try {
    const empresaRedirect = await checkEmpresa({ store, to, from });
    
    if (empresaRedirect) {
      // Si el guard pide redirigir (ej. a landing) y no estamos ya ahí, redirigimos.
      if (to.name !== empresaRedirect.name) {
        console.log(`%c${prefix} REDIRECCIÓN DE INFRAESTRUCTURA -> ${empresaRedirect.name}`, 'color: #BA6B30; font-weight: bold;');
        return next(empresaRedirect);
      }
    }
  } catch (error) {
    console.error(`${prefix} Error crítico en checkEmpresa:`, error);
    return next({ name: 'error', params: { errorMessage: 'Error validando instancia' } });
  }

  // 2. CLÁUSULA DE ESCAPE PARA RUTAS PÚBLICAS
  // Si llegamos aquí, checkEmpresa ya dio el "OK".
  // Si la ruta es pública, la landing o el error, no pedimos Auth.
// 2. CLÁUSULA DE ESCAPE PARA RUTAS PÚBLICAS
  if (to.meta.public || to.name === 'landing' || to.name === 'error') {
    
    // --- NUEVO CHEQUEO DE ISLOGGED ---
    const isAuthenticated = store.state.auth.isLogged; // O usa tu getter store.getters['auth/isLogged']

    if (to.name === 'login' && isAuthenticated) {
      console.log(`%c${prefix} Usuario ya autenticado. Redirigiendo a raíz.`, 'color: #9C27B0; font-weight: bold;');
      return next({ path: '/' }); // O el nombre de tu ruta de inicio
    }

    console.log(`%c${prefix} RUTA LIBRE DETECTADA: ${to.name}.`, 'color: #4CAF50;');
    return next();
  }

  // 3. INICIO DE ZONA PROTEGIDA
  console.log(`%c${prefix} ENTRANDO A ZONA PROTEGIDA: ${to.name}`, 'color: #2196F3; font-weight: bold;');

  try {
    // Lista de guards de identidad y permisos
    const guards = [checkAuth, checkInitData, checkRoleAccess];

    for (let i = 0; i < guards.length; i++) {
      const guardName = guards[i].name;
      const result = await guards[i]({ store, to, from });

      if (result) {
        // Evitar bucles: si el guard me manda a donde ya intento ir, ignoro.
        if (result.name === to.name) continue;

        console.log(`%c${prefix} GUARD [${guardName}] bloqueó acceso. Redirigiendo...`, 'color: #FF5252;');
        return next(result);
      }
    }

    // 4. VALIDACIONES FINALES (Si las tienes)
    console.log(`%c${prefix} TODO OK. Acceso concedido.`, 'color: #4CAF50; font-weight: bold;');
    return next();

  } catch (error) {
    console.error(`${prefix} EXCEPCIÓN EN CADENA DE SEGURIDAD:`, error);
    next({ name: 'error', params: { errorMessage: 'Error de autenticación' } });
  }
});
export default router